module.exports = __webpack_public_path__ + "img/huracanes.dcd8bfac.png";